
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const moduleMsg = {
  state: {
    msgActive: false,
    msgType: 'info',
    msgText: '',
    timeOut: 1200
  },
  mutations: {
    showMessage (state, Message) {
      state.msgType = Message.type
      state.msgText = Message.text
      if (Message.timeOut) state.timeOut = Message.timeOut; else state.timeOut = 1200
      state.msgActive = true
    },
    closeMessage (state) {
      state.msgActive = false
    }
  },
  getters: {
    getMsgType (state) {
      return state.msgType
    },
    getMsgText (state) {
      return state.msgText
    },
    getMsgActive (state) {
      return state.msgActive
    },
    getTimeout (state) {
      return state.timeOut
    }
  }
}
